import { useMemo } from 'react';

import { MASTER_SOURCE_OPTION } from '../components/radio/constants';

export default function useSourceOptions(venuesOptions) {
    const options = useMemo(() => {
        let options = [{ label: $t('Central'), options: [MASTER_SOURCE_OPTION] }];

        if (!venuesOptions) {
            return options;
        }

        options = options.concat(venuesOptions);

        return options;
    }, [venuesOptions]);

    return options;
}
